import { render, staticRenderFns } from "./SignatureProfiles.vue?vue&type=template&id=f654d87e&scoped=true"
import script from "./SignatureProfiles.vue?vue&type=script&lang=js"
export * from "./SignatureProfiles.vue?vue&type=script&lang=js"
import style0 from "./SignatureProfiles.vue?vue&type=style&index=0&id=f654d87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f654d87e",
  null
  
)

export default component.exports